var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "advance-download" },
    [
      _c(
        "vuestic-widget",
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: { inline: true, model: _vm.advanceForm },
              on: { submit: _vm.submit },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("t.app") + "：",
                    "label-width": "37px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("common.selectPlaceholder"),
                      },
                      model: {
                        value: _vm.advanceForm.app_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.advanceForm, "app_id", $$v)
                        },
                        expression: "advanceForm.app_id",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("basic.select.all"),
                          value: "",
                          selected: "",
                        },
                      }),
                      _vm._l(_vm.appList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("t.method") + "：",
                    "label-width": "58px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: _vm.$t("common.selectPlaceholder"),
                      },
                      model: {
                        value: _vm.advanceForm.method,
                        callback: function ($$v) {
                          _vm.$set(_vm.advanceForm, "method", $$v)
                        },
                        expression: "advanceForm.method",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("basic.select.all"),
                          value: "",
                          selected: "",
                        },
                      }),
                      _vm._l(_vm.methodList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: { label: item, value: item },
                        })
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("report.timeZone") + "：",
                    "label-width": "76px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: _vm.$t("ticket.select") },
                      model: {
                        value: _vm.advanceForm.zone_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.advanceForm, "zone_id", $$v)
                        },
                        expression: "advanceForm.zone_id",
                      },
                    },
                    [
                      _c(
                        "el-option",
                        { attrs: { value: "America/Sao_Paulo" } },
                        [_vm._v("America/Sao_Paulo")]
                      ),
                      _c("el-option", { attrs: { value: "Etc/GMT" } }, [
                        _vm._v("Etc/GMT"),
                      ]),
                      _c("el-option", { attrs: { value: "Asia/Shanghai" } }, [
                        _vm._v("Asia/Shanghai"),
                      ]),
                      _c(
                        "el-option",
                        { attrs: { value: "America/Mexico_City" } },
                        [_vm._v("America/Mexico_City")]
                      ),
                      _c("el-option", { attrs: { value: "America/Bogota" } }, [
                        _vm._v("America/Bogota"),
                      ]),
                      _c(
                        "el-option",
                        { attrs: { value: "America/Santiago" } },
                        [_vm._v("America/Santiago")]
                      ),
                      _c("el-option", { attrs: { value: "America/Lima" } }, [
                        _vm._v("America/Lima"),
                      ]),
                      _c("el-option", { attrs: { value: "America/Panama" } }, [
                        _vm._v("America/Panama"),
                      ]),
                      _c(
                        "el-option",
                        { attrs: { value: "America/Costa_Rica" } },
                        [_vm._v("America/Costa_Rica")]
                      ),
                      _c(
                        "el-option",
                        { attrs: { value: "America/Guayaquil" } },
                        [_vm._v("America/Guayaquil")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("t.dateRange") + "：",
                    "label-width": "81px",
                  },
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "unlink-panels": "",
                      "range-separator": "-",
                      "start-placeholder": _vm.$t("report.startDate"),
                      "end-placeholder": _vm.$t("report.endDate"),
                      format: "yyyy-MM-dd",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.advanceForm.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.advanceForm, "time", $$v)
                      },
                      expression: "advanceForm.time",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("t.fileType") + "：",
                    "label-width": "76px",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.advanceForm.file_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.advanceForm, "file_type", $$v)
                        },
                        expression: "advanceForm.file_type",
                      },
                    },
                    _vm._l(_vm.fileTypeOptions, function (mvalue, name, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: name, value: mvalue },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "btn btn-primary btn-micro",
                  on: { click: _vm.download },
                },
                [_vm._v(_vm._s(_vm.$t("menu.download")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "advance-table" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn btn-info btn-micro advance-refresh",
              on: {
                click: function ($event) {
                  return _vm.refresh()
                },
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm._f("translate")("t.refresh")) + "\n    "
              ),
            ]
          ),
          _c(
            "el-table",
            {
              ref: "advanceTable",
              attrs: {
                data: _vm.tableData,
                "empty-text": _vm.$t("t.noDataNoOrder"),
              },
              on: { "row-click": _vm.handleRowClick },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "date",
                  label: _vm.$t("report.showDetails"),
                  type: "expand",
                  width: "110",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-form",
                          {
                            staticClass: "details-expand",
                            attrs: { "label-position": "left", inline: "" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-child" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: _vm.$t("appName") + "：" },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          JSON.parse(props.row.conditions)
                                            .app_name || "ALL"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: _vm.$t("t.method") + "：" },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          JSON.parse(props.row.conditions)
                                            .method || "ALL"
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "create_time",
                  label: _vm.$t("tables.listing.referenceDateTime"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "start_time",
                  label: _vm.$t("report.start"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "end_time",
                  label: _vm.$t("report.end"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "", label: _vm.$t("report.result") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 2
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDownloadResult(scope.row.result)
                                )
                              ),
                            ])
                          : scope.row.status == 1
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("report.fail")))])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.$t("report.processing"))),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "update_time",
                  label: _vm.$t("tables.listing.updateTime"),
                  "min-width": "90px",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "", label: _vm.$t("tables.apping.status") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status == 2
                          ? _c(
                              "span",
                              [
                                _c("DownloadFileButton", {
                                  attrs: { "download-log-id": scope.row.id },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                }),
                                _c("DownloadPasswordButton", {
                                  attrs: { "download-log-id": scope.row.id },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : scope.row.status == 1
                          ? _c("span", [_vm._v(_vm._s(_vm.$t("report.fail")))])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.$t("report.processing"))),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 25, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }